<div class="time-input__box">
  @if (control.enabled) {
    <mat-icon
      (click)="incrementValue()"
      (mousedown)="startChanging(1)"
      (mouseup)="stopChanging()"
      (mouseleave)="stopChanging()"
      [ngClass]="{ disabled: +input.value + 1 > maxValue }"
      >expand_less</mat-icon
    >
  }
  <input
    #input
    type="text"
    [formControl]="control"
    [maxlength]="maxNumberOfDigits"
    [ngClass]="inputWidthClass"
    (keypress)="preventNonNumericalInput($event)"
    (change)="onChange(input.value)"
  />
  @if (control.enabled) {
    <mat-icon
      (click)="decrementValue()"
      (mousedown)="startChanging(-1)"
      (mouseup)="stopChanging()"
      (mouseleave)="stopChanging()"
      [ngClass]="{ disabled: +input.value - 1 < minValue }"
      >expand_more</mat-icon
    >
  }
</div>
